import React from "react";
import Dropdown from "./ui/Dropdwon";
import Button from "./ui/Button";
import { FaEllipsisH } from "react-icons/fa";
import useFetch from "../hooks/useFetch";
import { REVERSE_STATUS_MAPPER } from "../constants/OutreachedJobs";
import { GlobalToggle } from "./drawer/aiAgent/AiAgent";
import Tooltip from "./ui/Tooltip";

const OutReachedAction = ({ jid, status, jobstatus, companyId }) => {
  const isClosed = jobstatus === "Closed";
  const finalStatus = REVERSE_STATUS_MAPPER.ONGOING === status;
  const notStarted = REVERSE_STATUS_MAPPER.NOT_STARTED === status;

  const { refetch } = useFetch(
    "/api/v1/toggle-auto-sourcing",
    {
      method: "post",
      data: {
        job_uuid: jid,
        sourcing_active: !finalStatus,
      },
    },
    false
  );

  if (isClosed) {
    return (
      <div className="flex items-center justify-center">
        <Tooltip
          tooltip={
            <span>
              Job is closed.
            </span>
          }
        >
          <FaEllipsisH className="text-gray-300 h-4 w-4 cursor-pointer" />
        </Tooltip>
      </div>
    );
  }

  return (
    notStarted ?  <GlobalToggle
              companyId={companyId}
              jobId={jid}
              variant="black"
            >
              Start Outreach
            </GlobalToggle> :
    <Dropdown
      trigger={
        <Button variant="icon" size="icon">
          <FaEllipsisH />
        </Button>
      }
      options={[
        {
          label: (
            <GlobalToggle
              variant="textBased"
              companyId={companyId}
              jobId={jid}
              className="text-sm !px-0 !py-0 font-normal"
            >
              {" "}
              Change preferences{" "}
            </GlobalToggle>
          ),
          onClick: () => {},
        },
        {
          label: finalStatus ? (
            <div className="text-sm text-red-500 font-normal">
              Pause Outreach
            </div>
          ) : (
            <div className="text-sm text-green-500 font-normal">
              Resume Outreach
            </div>
          ),
          onClick: () => refetch().then(() => window.location.reload()),
        },
      ]}
    />
  );
};

export default OutReachedAction;
